import React, { Component } from 'react';
import Select from '../select';
import { Size } from '../_util/enum';
export default class LargeSelect extends Component {
    render() {
        return React.createElement(Select, Object.assign({ size: Size.large }, this.props));
    }
}
LargeSelect.Option = Select.Option;
